import { Loader } from '@googlemaps/js-api-loader'
import { GeocoderService } from '~/services/geocoder-service'

/**
 * @description
 * This composable is used to instantiate the Google Maps services
 * so the google-place.ts lib methods can work properly
 * this will also force developers to use the lib correctly
 * preventing the error nuxt instance is not available
 *
 * @example
 * const { GetAutoCompleteService, GetGeoCoderService } = useGooglePlaceLib()
 *
 * @returns {Loader} googleMapsLoader
 * @returns {Promise<google.maps.places.AutocompleteService>} GetAutoCompleteService
 * @returns {Promise<GeocoderService>} GetGeoCoderService
 */

export const useGooglePlaceLib = () => {
  const app = useNuxtApp()
  const autocompleteService = ref<google.maps.places.AutocompleteService>()
  const geocoderService = ref<GeocoderService>()

  const googleMapsLoader = (): Loader => app.$googleMapsLoader

  const GetAutoCompleteService = async (): Promise<google.maps.places.AutocompleteService> => {
    if (autocompleteService.value) return autocompleteService.value

    const { AutocompleteService } = (await googleMapsLoader().importLibrary('places')) as google.maps.PlacesLibrary
    autocompleteService.value = new AutocompleteService()
    return autocompleteService.value
  }

  const GetGeocoderService = async (): Promise<GeocoderService> => {
    if (geocoderService.value) return geocoderService.value

    geocoderService.value = new GeocoderService()
    return geocoderService.value
  }

  return {
    googleMapsLoader,
    GetAutoCompleteService,
    GetGeocoderService
  }
}
